/**
 * MSAL exports shim — centralises all @azure/msal-react imports.
 *
 * When REACT_APP_AUTH_BYPASS=true (local Docker dev), this module
 * exports lightweight mocks so the app can render without Azure B2C.
 * Otherwise it re-exports from the real @azure/msal-react package.
 */
import React from 'react'; // eslint-disable-line no-unused-vars

const isAuthBypass = process.env.REACT_APP_AUTH_BYPASS === 'true';

let MsalProvider,
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    MsalAuthenticationTemplate;

if (isAuthBypass) {
    // ── Mock implementations ────────────────────────────────────────
    console.log('[Auth] AUTH BYPASS mode enabled — Azure B2C disabled');

    function MockMsalProvider({ children }) { return <>{children}</>; } // eslint-disable-line no-inner-declarations
    function MockAuthenticatedTemplate({ children }) { return <>{children}</>; } // eslint-disable-line no-inner-declarations
    function MockUnauthenticatedTemplate() { return null; } // eslint-disable-line no-inner-declarations
    function MockMsalAuthenticationTemplate({ children }) { return <>{children}</>; } // eslint-disable-line no-inner-declarations

    MsalProvider = MockMsalProvider;
    AuthenticatedTemplate = MockAuthenticatedTemplate;
    UnauthenticatedTemplate = MockUnauthenticatedTemplate;
    MsalAuthenticationTemplate = MockMsalAuthenticationTemplate;

    useMsal = () => ({
        instance: null,
        accounts: [{ username: 'dev@local.test', name: 'Local Developer' }],
        inProgress: 'none',
    });

    useIsAuthenticated = () => true;
} else {
    // ── Real MSAL ───────────────────────────────────────────────────
    const msalReact = require('@azure/msal-react');
    MsalProvider = msalReact.MsalProvider;
    AuthenticatedTemplate = msalReact.AuthenticatedTemplate;
    UnauthenticatedTemplate = msalReact.UnauthenticatedTemplate;
    useMsal = msalReact.useMsal;
    useIsAuthenticated = msalReact.useIsAuthenticated;
    MsalAuthenticationTemplate = msalReact.MsalAuthenticationTemplate;
}

export {
    MsalProvider,
    AuthenticatedTemplate,
    UnauthenticatedTemplate,
    useMsal,
    useIsAuthenticated,
    MsalAuthenticationTemplate,
};
